/* eslint no-restricted-syntax: "off" */

import events from '../map-events/map-events';

export default class DropdownModule {
    constructor(params, uniqueId) {
        // TODO: check and output errors if params not provided:
        this.params = {
            ...params,
        };

        this.uniqueId = uniqueId;
        this.renderDropdownMenu(this.params.rootElement, this.params.items, this.params.defaultRegionId);

        events.on('vj-map', (eventObject) => {
            const { type, content, id } = eventObject;

            if (type === 'region-changed') {
                // check if dropdown matches unique ID from message (or undefined):
                if (id === this.uniqueId) {
                    if (content) {
                        this.updateDropdown(this.params.rootElement, content);
                    }
                }
            }
        });
    }

    /**
     * Adds to the DOM all the select options for the dropdown menu, from the regions object.
     * @param {String} rootElement The selector of the dropdown menu.
     * @param {*} regions The object containing all the region names.
     * @param {String} defaultRegion The region that should be selected by default.
     */
    renderDropdownMenu(rootElement, regions, defaultRegion) {
        const regionsArray = Object.entries(regions);
        const dropdownDom = rootElement;
        // adding up all HTML for dropdown:
        if (regionsArray.length > 0) {
            const dropdownOptionsHtml = Object.entries(regions)
                .sort((a, b) => {
                    if (a[0] === 'ZH') {
                        return -1;
                    }
                    if (b[0] === 'ZH') {
                        return 1;
                    }
                    return (a[1] > b[1]) ? 1 : -1;
                })
                .reduce((previous, current) => {
                    const [key, entry] = current;
                    const selected = key === defaultRegion ? 'selected="selected"' : '';
                    const accumulator = `${previous}<option value="${key}" ${selected}>${entry}</option>`;
                    return accumulator;
                }, '');
            // add HTML to dom:
            dropdownDom.innerHTML = dropdownOptionsHtml;
        }
        dropdownDom.addEventListener('change', (event) => this.dropdownChanged(event));
    }

    /**
     * When the user selects a value from the dropdown, update the map.
     * @param {*} event From the 'change' event listener.
     */
    dropdownChanged(event) {
        const region = event.target.value;
        events.emit('vj-map', {
            type: 'region-changed',
            content: region,
            id: this.uniqueId,
        });
    }

    /**
     * When the map is updated (clicked on, etc), update the dropdown menu.
     * @param {*} rootElement The DOM element for the Dropdown root.
     * @param {*} region The region/country which has been selected by the user.
     */
    updateDropdown(rootElement, region) {
        const dropdownDomOption = rootElement.querySelector(`option[value="${region}"]`);
        // select specific region/country in dropdown:
        dropdownDomOption.selected = true;
    }
}
